export const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL || "https://aqgeoubahtnbzgfglgky.supabase.co";
export const SUPABASE_ANON_KEY =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  "sb_publishable_JMyqZ7HaootcpW0DMMaUhQ_HAk2y7Gj";

const SESSION_KEY = `ken-and-bryn-admin-session:${SUPABASE_URL}`;

function headers(accessToken) {
  return {
    apikey: SUPABASE_ANON_KEY,
    Authorization: `Bearer ${accessToken || SUPABASE_ANON_KEY}`,
    "Content-Type": "application/json",
  };
}

async function parseResponse(response) {
  if (response.ok) {
    return response.status === 204 ? null : response.json();
  }

  const body = await response.json().catch(() => ({}));
  const error = new Error(
    body.msg || body.message || body.error_description || body.error || "Request failed"
  );
  error.status = response.status;
  throw error;
}

function saveSession(session) {
  const withExpiry = {
    ...session,
    expires_at: session.expires_at || Math.floor(Date.now() / 1000) + session.expires_in,
  };
  localStorage.setItem(SESSION_KEY, JSON.stringify(withExpiry));
  return withExpiry;
}

export function getStoredSession() {
  try {
    return JSON.parse(localStorage.getItem(SESSION_KEY));
  } catch {
    localStorage.removeItem(SESSION_KEY);
    return null;
  }
}

export async function signIn(email, password) {
  const response = await fetch(`${SUPABASE_URL}/auth/v1/token?grant_type=password`, {
    method: "POST",
    headers: headers(),
    body: JSON.stringify({ email, password }),
  });
  return saveSession(await parseResponse(response));
}

export async function getAccessToken() {
  const session = getStoredSession();
  if (!session) throw new Error("Please sign in again.");

  if (session.expires_at > Math.floor(Date.now() / 1000) + 30) {
    return session.access_token;
  }

  const response = await fetch(`${SUPABASE_URL}/auth/v1/token?grant_type=refresh_token`, {
    method: "POST",
    headers: headers(),
    body: JSON.stringify({ refresh_token: session.refresh_token }),
  });
  return saveSession(await parseResponse(response)).access_token;
}

export async function getCurrentUser() {
  const accessToken = await getAccessToken();
  const response = await fetch(`${SUPABASE_URL}/auth/v1/user`, {
    headers: headers(accessToken),
  });
  return parseResponse(response);
}

export async function isCurrentUserAdmin() {
  return adminApi("rpc/is_admin", { method: "POST", body: "{}" });
}

export async function signOut() {
  const session = getStoredSession();
  localStorage.removeItem(SESSION_KEY);
  if (!session?.access_token) return;

  await fetch(`${SUPABASE_URL}/auth/v1/logout`, {
    method: "POST",
    headers: headers(session.access_token),
  }).catch(() => {});
}

export async function publicApi(path, options = {}) {
  const response = await fetch(`${SUPABASE_URL}/rest/v1/${path}`, {
    ...options,
    headers: { ...headers(), ...options.headers },
  });
  return parseResponse(response);
}

export async function adminApi(path, options = {}) {
  const accessToken = await getAccessToken();
  const response = await fetch(`${SUPABASE_URL}/rest/v1/${path}`, {
    ...options,
    headers: { ...headers(accessToken), ...options.headers },
  });
  return parseResponse(response);
}

export async function adminStorageApi(path, options = {}) {
  const accessToken = await getAccessToken();
  const response = await fetch(`${SUPABASE_URL}/storage/v1/${path}`, {
    ...options,
    headers: {
      apikey: SUPABASE_ANON_KEY,
      Authorization: `Bearer ${accessToken}`,
      ...options.headers,
    },
  });
  return parseResponse(response);
}
